import React from 'react';
import { areProgramMetadataValid, formTimeString, getLiveDateStringFromPercentageWithinDVRWindow, getLiveDateStringFromPercentageWithinProgramWindow, getLiveProgressFromPercentageWithinDVRWindow, } from '@24i/player-utils';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { ProgressTimeContainer } from '../../styled';
import { Time, Container } from './styled';
const PERCENT = 100;
const HOUR_MS = 60 * 60 * 1000;
export const ProgressTime = ({ progress = 0, duration, isVisible, className = '', playerInstance, programRange, showHours = true, styles = {
    container: null,
    backgroundContainer: null,
    time: null,
}, }) => {
    var _a, _b;
    const numericPercentage = progress / PERCENT;
    const isLive = !!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live);
    const { start, end } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.timeshiftRange) || {
        start: 0,
        end: 0,
    };
    const { programStart, programEnd } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.getMetadata()) || {
        programStart: 0,
        programEnd: 0,
    };
    const rangeStart = (_a = programRange === null || programRange === void 0 ? void 0 : programRange.start) !== null && _a !== void 0 ? _a : programStart;
    const rangeEnd = (_b = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _b !== void 0 ? _b : programEnd;
    let milliseconds;
    if (!isLive) {
        milliseconds = numericPercentage * duration;
    }
    else if (areProgramMetadataValid(rangeStart, rangeEnd)) {
        milliseconds = getLiveDateStringFromPercentageWithinProgramWindow(rangeStart, rangeEnd, numericPercentage);
    }
    else {
        const target = getLiveProgressFromPercentageWithinDVRWindow(start, end, numericPercentage);
        const timestamp = playerInstance.getUTCTimestamp(target);
        if (timestamp) {
            milliseconds = timestamp.getTime();
        }
        else {
            milliseconds = getLiveDateStringFromPercentageWithinDVRWindow(start, end, numericPercentage, Date.now());
        }
    }
    const finalShowHours = showHours === true || (showHours === 'auto' && milliseconds > HOUR_MS);
    const timeString = formTimeString(milliseconds, finalShowHours, isLive);
    const { theme } = useTheme();
    return (React.createElement(ProgressTimeContainer, { progress, className: `${className} ProgressTime`, style: styles.container }, isVisible && (React.createElement(Container, { style: styles.backgroundContainer, "data-test": "ProgressTime-Container", className: "ProgressTime-Container" },
        React.createElement(Time, { style: Object.assign(Object.assign({}, getFont(theme, 'h5')), styles.time), "data-test": "ProgressTime-Time", className: "ProgressTime-Time", theme: theme }, timeString)))));
};
//# sourceMappingURL=index.js.map